(() => {
  const initialize = () => {
    document.querySelectorAll('[data-bsn-search-menu]').forEach(details => {
      if (details.dataset.menuBound) return;
      const controller = details.closest('details-modal');
      const header = details.closest('.header');
      const wrapper = details.closest('.header-wrapper');
      const panel = details.querySelector('.bsn-search-menu');
      const summary = details.querySelector('summary');
      if (!controller || !header || !wrapper || !panel || !summary) return;
      details.dataset.menuBound = 'true';
      // Keep the panel attached to the header wrapper; absolute positioning overlays page content.
      panel.hidden = !details.open;
      wrapper.append(panel);
      const hiddenElements = [...header.querySelectorAll('.header__inline-menu'), ...header.querySelectorAll('.header__icons > :not(.header__search)'), ...header.querySelectorAll(':scope > header-drawer')];
      const inertState = new Map();
      const previousPreventHide = wrapper.preventHide;
      const previousTabIndex = summary.getAttribute('tabindex');
      const position = () => {
        const starting = panel.querySelector('.bsn-search-menu__initial');
        const startingLabel = starting?.querySelector('.bsn-search-menu__heading');
        const startingTiles = starting?.querySelector('.bsn-search-menu__panels');
        if (startingLabel && startingTiles) {
          if (window.matchMedia('(max-width: 1099px)').matches) starting.insertBefore(startingLabel, startingTiles);
          else starting.append(startingLabel);
        }
        const box = wrapper.getBoundingClientRect();
        const headerBox = header.getBoundingClientRect();
        const logoBox = header.querySelector('.header__heading-link')?.getBoundingClientRect();
        const gutter = parseFloat(getComputedStyle(header).paddingRight) || 24;
        panel.style.setProperty('--bsn-menu-row-height', `${Math.round(headerBox.height)}px`);
        panel.style.setProperty('--bsn-menu-left', `${Math.round((logoBox?.right || headerBox.left + gutter) - box.left + 24)}px`);
        panel.style.setProperty('--bsn-menu-right', `${Math.round(box.right - headerBox.right + gutter)}px`);
      };
      const update = () => {
        position();
        panel.hidden = !details.open;
        summary.setAttribute('aria-expanded', String(details.open));
        wrapper.preventHide = details.open ? true : previousPreventHide;
        if (details.open) summary.setAttribute('tabindex', '-1');
        else if (previousTabIndex === null) summary.removeAttribute('tabindex');
        else summary.setAttribute('tabindex', previousTabIndex);
        if (details.open) {
          header.querySelectorAll('header-menu details[open]').forEach(menu => menu.removeAttribute('open'));
          hiddenElements.forEach(element => {
            if (!inertState.has(element)) inertState.set(element, element.inert);
            element.inert = true;
          });
        } else {
          inertState.forEach((inert, element) => { element.inert = inert; });
          inertState.clear();
        }
      };
      const close = (focusToggle = true) => {
        details.open = false;
        update();
        panel.querySelector('predictive-search')?.close();
        if (focusToggle) summary.focus({ preventScroll: true });
      };
      // Preserve Dawn's summary and sticky-header integration, using a nonmodal expansion.
      controller.open = () => {
        details.open = true;
        update();
        panel.querySelector('input[name="q"]')?.focus({ preventScroll: true });
      };
      controller.close = close;
      panel.querySelector('.search-modal__close-button')?.addEventListener('click', () => close());
      details.addEventListener('toggle', update);
      document.addEventListener('keyup', event => {
        if (event.key === 'Escape' && details.open) close();
      });
      document.addEventListener('click', event => {
        if (details.open && !wrapper.contains(event.target)) close(false);
      });
      window.addEventListener('resize', position);
      update();
    });
  };
  customElements.whenDefined('details-modal').then(initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
